<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="leftLoader"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-alert
        variant="primary"
        show
      >
        <div class="left-side">
          <b-button
            v-for="button in moduleButtons"
            :key="button.id"
            :variant="getBtnVariant(button.button_color)"
            class="full-width mb-1"
            @click="getButtonModules(button.id, button.button_title)"
          >
            {{ button.button_title }}
          </b-button>
        </div>
      </b-alert>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay, BAlert, BButton,
} from 'bootstrap-vue'
// import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
// import i18n from '@/libs/i18n'
// import AddModuleModal from './AddModuleModal.vue'

export default {
  components: {
    BOverlay,
    BAlert,
    BButton,
    // BCard,
  },
  directives: {
    Ripple,
  },
  props: {
    moduleButtons: {
      type: Array,
      required: true,
    },
    moduleId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userType: JSON.parse(localStorage.getItem('userData')).role[0],
      collapseType: 'margin',
      leftLoader: false,
    }
  },
  watch: {
    state: {
      handler() {
        this.stateNumber = this.state
      },
    },
  },
  created() {
  },
  methods: {
    getButtonModules(id, title) {
      // console.log('id is ', id)
      const obj = {
        btn_title: title,
        btnID: id,
        moduleId: this.moduleId,
      }
      EventBus.$emit('getBtnIdModules', obj)
    },
    getBtnVariant(variant) {
      const btncolor = variant.includes('#') ? 'relief-primary' : `relief-${variant.toLowerCase()}`
      return btncolor
    },
  },
}
</script>

<style lang="scss">
.btn-list {
    margin-bottom: 10px;
}
.details-section {
    padding-left: 0px;
}
.left-side{
    padding:20px;
}
.details-header {
    border-bottom: 1px solid #ffffff !important;
    margin-bottom: 20px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
</style>
